// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ChatScrollController from "./chat_scroll_controller"
application.register("chat-scroll", ChatScrollController)

import ClipFormController from "./clip_form_controller"
application.register("clip-form", ClipFormController)

import ClipsBackController from "./clips_back_controller"
application.register("clips-back", ClipsBackController)

import CommandPaletteController from "./command_palette_controller"
application.register("command-palette", CommandPaletteController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import InfiniteScrollController from "./infinite_scroll_controller"
application.register("infinite-scroll", InfiniteScrollController)

import InlineEditController from "./inline_edit_controller"
application.register("inline-edit", InlineEditController)

import MobileNavController from "./mobile_nav_controller"
application.register("mobile-nav", MobileNavController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import SlashCommandController from "./slash_command_controller"
application.register("slash-command", SlashCommandController)

import ThemeToggleController from "./theme_toggle_controller"
application.register("theme-toggle", ThemeToggleController)

import YoutubeEmbedController from "./youtube_embed_controller"
application.register("youtube-embed", YoutubeEmbedController)
